// extracted by mini-css-extract-plugin
export default {"app-button":"Button_app-button__0swUU"};